import { render } from "./InventoryDataStaging.vue?vue&type=template&id=635cb01e&scoped=true"
import script from "./InventoryDataStaging.vue?vue&type=script&lang=js"
export * from "./InventoryDataStaging.vue?vue&type=script&lang=js"

import "./InventoryDataStaging.vue?vue&type=style&index=0&id=635cb01e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635cb01e"]])

export default __exports__